import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, HostListener, inject, ChangeDetectionStrategy } from '@angular/core';
import { DrawerService } from '../../services/right-drawer/right-drawer.service';

@Component({
  selector: 'app-right-drawer',
  templateUrl: './right-drawer.component.html',
  styleUrls: ['./right-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RightDrawerComponent implements OnChanges {
  private drawerService = inject(DrawerService);

  /** Module name e.g. 'user', 'role', etc. */
  @Input() moduleName = '';

  /** Record ID to fetch */
  @Input() recordId: number | null = null;

  /** Control visibility */
  @Input() isOpen = false;

  /** Emit close event */
  @Output() closed = new EventEmitter<void>();

  record: any = null;
  isLoading = false;

  selectedLayout = 'horizontal';
  selectedTheme = 'light';
  currentYear = new Date().getFullYear();

  ngOnChanges(changes: SimpleChanges): void {
    const shouldFetch =
      this.isOpen &&
      this.moduleName &&
      this.recordId &&
      (changes['isOpen'] || changes['recordId'] || changes['moduleName']);

    if (shouldFetch) this.fetchRecord();

    // Manage body scroll lock
    if (this.isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }

  /** Close drawer */
  close(): void {
    this.isOpen = false;
    document.body.style.overflow = 'auto';
    this.closed.emit();
  }

  /** Handle ESC key to close */
  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: Event): void {
    if (this.isOpen) this.close();
  }

  /** Fetch record data */
  fetchRecord(): void {
    if (!this.moduleName || !this.recordId) return;
    this.isLoading = true;
    this.drawerService.getRecordByModuleAndId(this.moduleName, this.recordId).subscribe({
      next: (data) => {
        this.record = data;
        this.isLoading = false;
      },
      error: () => (this.isLoading = false),
    });
  }
  
  /** Reset UI example */
  reset(): void {
    this.selectedLayout = 'horizontal';
    this.selectedTheme = 'light';
  }
}